import get = require('lodash/get');

export interface IExperimentMap {
  [name: string]: {
    experimentName: string;
    group: string|boolean;
    payload: string|boolean;
  };
}

declare const __EXPERIMENTS__: IExperimentMap;
export const EXPERIMENTS = (window as any).__EXPERIMENTS__ || __EXPERIMENTS__ || {};

export const isExperimentEnabled = (name: string, group: string|boolean = true): boolean => (
  get(EXPERIMENTS, [name, 'group']) === group
);
